import { useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, increment, serverTimestamp } from 'firebase/firestore';

const VisitorTracker = () => {
    useEffect(() => {
        const trackVisit = async () => {
            // Check session storage to prevent duplicate counts on refresh
            if (sessionStorage.getItem('visited_session')) {
                return;
            }

            sessionStorage.setItem('visited_session', 'true');

            const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

            try {
                // 1. Increment Global Counter
                const globalRef = doc(db, 'visitor_stats', 'global');
                const globalSnap = await getDoc(globalRef);

                if (!globalSnap.exists()) {
                    await setDoc(globalRef, { totalVisits: 1 });
                } else {
                    await updateDoc(globalRef, { totalVisits: increment(1) });
                }

                // 2. Increment Daily Counter
                const dailyRef = doc(db, 'visitor_stats', today);
                const dailySnap = await getDoc(dailyRef);

                if (!dailySnap.exists()) {
                    await setDoc(dailyRef, {
                        count: 1,
                        date: today,
                        timestamp: serverTimestamp()
                    });
                } else {
                    await updateDoc(dailyRef, { count: increment(1) });
                }

            } catch (error) {
                console.error("Error tracking visitor:", error);
            }
        };

        trackVisit();
    }, []);

    return null; // Interface-less component
};

export default VisitorTracker;
